// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","545":"component---src-pages-privacy-index-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"ef3b7d4ec13f3a025ce3","545":"623b2e02fbb2b17f3681","678":"a928767dae7db668c7ec"}[chunkId] + ".js";
};